<section
  *ngIf="(activeStepIndex$ | async) !== undefined"
  class="d-flex flex-row flex-grow-1"
  [class.logo-only]="authorizedPayment()"
>
  <div class="d-flex flex-column flex-grow-1" *ngIf="steps$ | async as steps">
    <ul class="d-flex flex-row align-items-start m-0">
      <li class="col p-0 align-self-start align-self-md-center mt-md-0 mt-1">
        <a class="logo justify-content-start" routerLink="/">
          <img
            class="img-fluid"
            [alt]="'altText.habaLogo' | cxTranslate"
            src="{{ wehrfritzLogoSrc }}"
            [width]="wehrfritzLogoWidth"
            [height]="wehrfritzLogoHeight"
          />
        </a>
      </li>
      <ng-container *ngFor="let step of steps; let i = index">
        <li
          *ngIf="!authorizedPayment()"
          class="col p-0"
          [class.active]="isActive(i)"
          [class.disabled]="isDisabled(i)"
          [class.checked]="getTabIndex(i) === 0"
        >
          <span class="progress" *ngIf="i !== 0"></span>
          <a
            class="text-decoration-none color-white d-flex flex-column align-items-center"
            [routerLink]="i === 0 ? [] : ({ cxRoute: step.routeName } | cxUrl)"
            [queryParams]="{ edit: true }"
            [class.active]="isActive(i)"
            [class.disabled]="isDisabled(i)"
            [tabindex]="getTabIndex(i)"
            [attr.data-qa]="stepButtonId.getButtonId() + '-' + step.id"
          >
            <span class="index-wrapper">
              <span class="index d-flex justify-content-center align-items-center font-bold">
                <ng-container *ngIf="getTabIndex(i) !== 0">{{ i + 1 }}</ng-container>
                <app-svg
                  class="checked-icon"
                  iconName="Check"
                  *ngIf="getTabIndex(i) === 0"
                  fill="white"
                ></app-svg>
              </span>
            </span>
            <span class="name text-center" [innerHtml]="step.name | cxTranslate"></span>
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</section>
